/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyerscustom2Inputs */

const en_placeflyerscustom2 = /** @type {(inputs: Placeflyerscustom2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design your own flyer with AI`)
};

const de_placeflyerscustom2 = /** @type {(inputs: Placeflyerscustom2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigenen Flyer mit KI gestalten`)
};

/**
* | output |
* | --- |
* | "Design your own flyer with AI" |
*
* @param {Placeflyerscustom2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyerscustom2 = /** @type {((inputs?: Placeflyerscustom2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyerscustom2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyerscustom2(inputs)
	return de_placeflyerscustom2(inputs)
});
export { placeflyerscustom2 as "placeFlyersCustom" }